import axios from 'axios'
import storage from '@/utils/storage'
import { Message } from 'element-ui'
import { refreshToken } from './refresh'
//  拿到axios
const request = axios

// request拦截器  此处并未创建axios实例  实例于应用时创建 只单纯做认证拦截即可
request.interceptors.request.use(config => {
  if (storage.session.get('token') !== '') {
    config.headers['catch'] = false
    config.headers['Authorization'] = storage.session.get('token') // 让每个请求携带自定义token请根据实际情况自行修改
  }
  return config
}, error => {
  Promise.reject(error)
})

// response拦截器
request.interceptors.response.use(
  response => {
    if (response.data.success !== true) {
      if (response.data.message === 'token过期' || response.data.message === 'token已过期' || response.data.message === 'token错误') {
        // 重新调用登陆接口
        refreshToken().then(response => {
          if (response.success === true) {
            storage.session.set('login_name', response.data.user.login_name)
            storage.session.set('id', response.data.user.id)
            storage.session.set('token', response.data.token)
          } else {
            this.$message.warning(response.message)
          }
        })
      } else {
        // 除了token过期外的其他返回false的  一律提示错误原因并留在当前页面
        Message({
          message: response.data.message,
          type: 'error',
          duration: 2 * 1000
        })
      }
    } else {
      try {
        const data = response.data.data
        const list = response.data.data.list
        if (data || list) {
          return Promise.resolve(response)
        }
      } catch (error) {
        return new Error(error)
      }
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 1.5 * 1000
    })
    return Promise.reject(error)
  }
)
export default request



// WEBPACK FOOTER //
// ./src/utils/request.js